/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type EmptyResponse = {};

export type ServiceCatalogRpcError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'DUPLICATE_API_NAME'
  | 'DUPLICATE_TRANSLATION_KEY'
  | unhandledEnumCase;

export type CreateServiceChirpRequest = {
  active: boolean;
  name: string;
  description?: string;
  translationKey?: string;
  categoryId: number;
  brief?: string;
  apiName?: string;
  credentials: Default<number[]>;
};

export type GetServiceByIdRequest = {
  id: number;
  language?: string;
  includeAllLanguages: Default<boolean>;
};

export type GetServicesByIdsRequest = {
  ids: Default<number[]>;
  language?: string;
  includeAllLanguages: Default<boolean>;
};

export type GetServicesPagedRequest = {
  categoryId?: number;
  apiName?: string;
  active: Default<boolean>;
  language?: string;
  includeAllLanguages: Default<boolean>;
  after?: string;
  before?: string;
  limit: Default<number>;
};

export type GetServicesRequest = {
  categoryId?: number;
  apiName?: string;
  active: Default<boolean>;
  language?: string;
  includeAllLanguages: Default<boolean>;
};

export type UpdateServiceChirpRequest = {
  id: number;
  active?: boolean;
  brief?: string;
  description?: string;
  apiName?: string;
  credentials?: number[];
};

export type ServiceMetadataResponse = {
  language: string;
  name: string;
  brief?: string;
  description?: string;
};

export type ServiceResponse = {
  id: number;
  createdAt: number;
  updatedAt: number;
  categoryId: number;
  externalId?: number;
  active: boolean;
  apiName?: string;
  language: string;
  name: string;
  brief?: string;
  description?: string;
  metadata: Default<ServiceMetadataResponse[]>;
  credentials: Default<number[]>;
};

export type ServiceResponseWrapper = { service?: ServiceResponse };

export type ServicesListResponse = { services: Default<ServiceResponse[]> };

export type ServicesPagedResponse = {
  results: Default<ServiceResponse[]>;
  after?: string;
  before?: string;
  hasMore: boolean;
};

export type GetServicesRequestType = Requestify<GetServicesRequest>;
export type GetServicesResponseType = ServicesListResponse;
export type GetServicesErrorType = EmptyError & HubspotMetadata;
export const getServicesRpc: ChirpAvroRpcDetails<
  GetServicesRequestType,
  GetServicesResponseType,
  GetServicesErrorType,
  false
> = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServices',
  auth: 'external',
  fingerprint: '2px9LAhjwB2WVLc1WsD9upwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetServiceByIdRequestType = Requestify<GetServiceByIdRequest>;
export type GetServiceByIdResponseType = ServiceResponseWrapper;
export type GetServiceByIdErrorType = EmptyError & HubspotMetadata;
export const getServiceByIdRpc: ChirpAvroRpcDetails<
  GetServiceByIdRequestType,
  GetServiceByIdResponseType,
  GetServiceByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServiceById',
  auth: 'external',
  fingerprint: 'RURPjuW49yx10AsEi57R0pwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetServicesPagedRequestType = Requestify<GetServicesPagedRequest>;
export type GetServicesPagedResponseType = ServicesPagedResponse;
export type GetServicesPagedErrorType = EmptyError & HubspotMetadata;
export const getServicesPagedRpc: ChirpAvroRpcDetails<
  GetServicesPagedRequestType,
  GetServicesPagedResponseType,
  GetServicesPagedErrorType,
  false
> = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServicesPaged',
  auth: 'external',
  fingerprint: 'dKC_3C9z82piYG15Za2blJwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetServicesByIdsRequestType = Requestify<GetServicesByIdsRequest>;
export type GetServicesByIdsResponseType = ServicesListResponse;
export type GetServicesByIdsErrorType = EmptyError & HubspotMetadata;
export const getServicesByIdsRpc: ChirpAvroRpcDetails<
  GetServicesByIdsRequestType,
  GetServicesByIdsResponseType,
  GetServicesByIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServicesByIds',
  auth: 'external',
  fingerprint: '_Xn4qIaXRLOWVLc1WsD9upwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateServiceRequestType = Requestify<CreateServiceChirpRequest>;
export type CreateServiceResponseType = ServiceResponse;
export type CreateServiceErrorType = ServiceCatalogRpcError & HubspotMetadata;
export const createServiceRpc: ChirpAvroRpcDetails<
  CreateServiceRequestType,
  CreateServiceResponseType,
  CreateServiceErrorType,
  false
> = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'createService',
  auth: 'external',
  fingerprint: '9wdEWhmVhU87FgX0XHMTNNbReT_HeIFC',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateServiceRequestType = Requestify<UpdateServiceChirpRequest>;
export type UpdateServiceResponseType = EmptyResponse;
export type UpdateServiceErrorType = ServiceCatalogRpcError & HubspotMetadata;
export const updateServiceRpc: ChirpAvroRpcDetails<
  UpdateServiceRequestType,
  UpdateServiceResponseType,
  UpdateServiceErrorType,
  false
> = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'updateService',
  auth: 'external',
  fingerprint: 'CNczh3FVcM2sRYZeXeAB5tbReT_HeIFC',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false,
};
